module.exports = __webpack_public_path__ + "static/media/Complete truck 1.bc97bf09.svg";